import React, { useEffect, useState } from 'react';
import data from "../Data.json";

const Populer = () => {
  const [cards, setCards] = useState([]);

  useEffect(() => {
    setCards(data.popular);
  }, []);

  return (
    <div className="main-container">
      <h1 className="main-heading">Populer</h1>
      <p className='peragraf'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat, nemo libero. Obcaecati inventore exercitationem,<br />
         sunt debitis rerum aperiam nostrum </p>
      <div className="circle-container">
        {cards.map((card) => (
          <div key={card.id} style={{ textAlign: 'center' }}>
            <div
              className="circle-card"
              style={{
                backgroundImage: `url(${card.backgroundImage})`,
              }}
            />
            <div className="card-footer">{card.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Populer;

